import { lazy } from 'react'
import { Route, Routes } from 'react-router'
import RouteErrorHandler from './RouteErrorHandler'
import ErrorBoundary from './ErrorBoundary'
import {
  ROUTE_HOME,
  ROUTE_MARKETS,
  ROUTE_PREFERENCES,
  ROUTE_SUBSCRIPTION,
} from '@Shared/constants/routes'
import IntercomInitializer from '@Utils/IntercomInitializer'

const Subscription = lazy(async () => await import('@Pages/Subscription'))
const Preferences = lazy(async () => await import('@Pages/Preferences'))
const Overview = lazy(async () => await import('@Pages/Overview'))
const Markets = lazy(async () => await import('@Pages/Markets'))

function Router(): JSX.Element {
  return (
    <ErrorBoundary>
      <IntercomInitializer>
        <Routes>
          <Route path={ROUTE_HOME} errorElement={<RouteErrorHandler />}>
            <Route path={ROUTE_PREFERENCES} element={<Preferences />} />
            <Route path={ROUTE_SUBSCRIPTION} element={<Subscription />} />
            <Route path={ROUTE_MARKETS} element={<Markets />} />
            <Route index element={<Overview />} />
          </Route>
        </Routes>
      </IntercomInitializer>
    </ErrorBoundary>
  )
}

export default Router
